export default __webpack_public_path__ + "static/media/elswedy.3efb7388.webp";